import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const QUESTIONS = [
  "カッとなって興奮してしまうことがよくある",
  "周囲から反対の意見があっても説得できると思う",
  "他人のことにはあまり関わりを持ちたくない",
  "周りの意見に流されやすい",
  "あとになって悔やむことがけっこうある",
  "自信はないが行動に移している、ということがよくある",
  "今まで激情したことがない",
  "楽天的な性格だと言われる",
  "多人数の前でもあがることなく話せる",
  "人間関係はむずかしいものだ",
  "どうしようもなく怒りがこみ上げてくることがある",
  "よく、人がいいと言われる",
  "他人の目が気になる",
  "約束を守れなかったことは一度もない",
  "ひまな時間は耐えられない",
  "口うるさいと人から言われることがある",
  "自分は自分、他人は他人、という割り切りかたをしている",
  "わけもなく気が滅入ってしまうことがある",
  "一度落ち込むと立ち直りにくい",
  "いつも失敗するのでは、と心配である",
  "人を疑ったことが一度もない",
  "エキサイトしやすい",
  "人に注意されるのは何か気分が悪い",
  "知り合いを見かけても、自分からは話しかけない",
  "周囲の環境にふりまわされることがよくある",
  "自分は世間の役に立っていないと思うときがある",
  "意味もなく心配にかられることがある",
  "他人の悪口は言ったためしがない",
  "にぎやかな集まりに加わるのは大好きだ",
  "反対されても自分の意見を通す",
  "個性的だと人から言われる",
  "自分は意志が弱いほうだと思う",
  "細かな失敗でも気にすることがよくある",
  "どちらかといえば心配性だ",
  "今まで弁解というものはしたことがない",
  "口数の多すぎることを注意されたことがある",
  "自尊心は強い",
  "人のことは見ても知らんぷりすることがある",
  "情緒不安定かもしれないと思うときがある",
  "過ぎたことでくよくよすることが多い",
  "物事に対する恐れは大きいほうだ",
  "人を傷つけるような行為はしたことがない",
  "周りのことに注意不足になることがある",
  "どんな困難も乗り越えていけると思う",
  "他人のことで口出しはしない",
  "自分の思い通りにならなかったら嫌だ",
  "やってしまったことを後悔することがよくある",
  "デリケートで傷つきやすい",
  "体調を崩したことは一度もない",
  "わけもなく、はしゃぎたくなるときがある",
  "他人を厳しく非難することがある",
  "人ごみは嫌いだ",
  "感情の起伏は激しいほうだと思う",
  "落ち込んで無気力になるときがある",
  "生真面目だと人から言われる",
  "決して人を憎いと思ったことはなかった",
  "調子のいい奴と言われることは多い",
  "知らない人の中でも、自分の意見をはっきり言える",
  "周りに悩みをうち明けられる人がいない",
  "突拍子もない行動に出ることが多い",
  "みんな自分の責任だと思うことがよくある",
  "さまざまなことに対して神経質になる",
  "怒ったことがない",
  "よく自分から遊びに行こうと人を誘う",
  "だいたい自己満足はしていると思う",
  "一人でいたいとよく思う",
  "その時々で考えを思いつくことが多い",
  "自分は周囲に対してやる気がないと思う",
  "環境の変化には鋭い",
  "人を嫌いだと思ったことは一度もない",
  "休日をのんびりと過ごすのは嫌だ",
  "他人が馬鹿らしく思えるときがある",
  "友だちとあまり出かけない",
  "一度決めても、人から異議をとなえられたらあきらめる",
  "一応人に聞いてからでないと決断できない",
  "自分の欠点がすごく気になる",
  "愚痴を言ったことはない",
  "心ここにあらずで行動しているときがある",
  "自分の意見が採用されないと納得できない",
  "知り合いを見かけると、避けることがある",
  "気まぐれな性格だ",
  "他人を責めるなんて間違っても出来ない",
  "小さなことが気になる",
  "どんなときでも落ち着き払っていられる",
];

const SCALE_NAMES = [
  "高揚性", "自信性", "独自性", "気分性", "自責性", "敏感性", "ライスケール"
];

const TIME_LIMIT = 7 * 60;

const GAS_ENDPOINT = 'https://script.google.com/macros/s/AKfycbwR4Mzv2wYR-ygoWh2eLQZf4ia57GBtidXBAVZeR2_pg4IFVOR2dnhI-mukRQZRkaXB3Q/exec';

function RecruitAssessmentPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [started, setStarted] = useState(false);
  const [answers, setAnswers] = useState({});
  const [timeLeft, setTimeLeft] = useState(TIME_LIMIT);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const timerRef = useRef(null);

  const calculateScores = useCallback(() => {
    var scores = {};
    for (var s = 0; s < 7; s++) {
      var count = 0;
      for (var i = s; i < 84; i += 7) {
        if (answers[i] === 'yes') count++;
      }
      scores[SCALE_NAMES[s]] = count;
    }
    return scores;
  }, [answers]);

  const doSubmit = useCallback(async (isTimeout) => {
    if (submitted || submitting) return;
    setSubmitting(true);

    var scores = calculateScores();
    var answeredCount = Object.keys(answers).length;

    try {
      if (GAS_ENDPOINT) {
        await fetch(GAS_ENDPOINT, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            formType: 'assessment',
            name: name,
            email: email,
            answeredCount: answeredCount,
            totalQuestions: 84,
            scores: scores,
            isTimeout: isTimeout,
            answers: answers,
            submittedAt: new Date().toISOString(),
          }),
        });
      }
      setSubmitted(true);
    } catch (err) {
      // no-cors doesn't throw on success
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  }, [submitted, submitting, answers, name, email, calculateScores]);

  useEffect(() => {
    if (started && !submitted) {
      timerRef.current = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(timerRef.current);
            doSubmit(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(timerRef.current);
    }
  }, [started, submitted, doSubmit]);

  const handleAnswer = (index, value) => {
    setAnswers(prev => ({ ...prev, [index]: value }));
  };

  const handleStart = (e) => {
    e.preventDefault();
    if (name && email) {
      setStarted(true);
    }
  };

  const handleSubmit = () => {
    clearInterval(timerRef.current);
    doSubmit(false);
  };

  var minutes = Math.floor(timeLeft / 60);
  var seconds = timeLeft % 60;
  var answeredCount = Object.keys(answers).length;

  // 開始前: 名前とメールを入力
  if (!started) {
    return (
      <div className="contact-page">
        <section className="page-header">
          <Container>
            <h1 className="page-title">Assessment</h1>
            <p className="page-subtitle">性格適性検査</p>
          </Container>
        </section>

        <section className="section-contact-before">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <div className="before-content">
                  <h3>検査を始める前にお読みください</h3>
                  <p>
                    以下の84問の質問に対して、該当すると思うものには「はい」を、
                    該当しないと思うものには「いいえ」を、<strong>直感的に</strong>回答してください。
                  </p>
                  <ul style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 2, marginTop: '1em' }}>
                    <li>制限時間は <strong>7分間</strong> です</li>
                    <li>深く考えず、直感で答えてください</li>
                    <li>時間切れになると自動で送信されます</li>
                    <li>正解・不正解はありません</li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="section-contact-form">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <form onSubmit={handleStart} className="contact-form">
                  <div className="form-group">
                    <label>氏名 <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="text" value={name} onChange={e => setName(e.target.value)} required placeholder="山田 花子" />
                  </div>
                  <div className="form-group">
                    <label>メールアドレス <span style={{ color: 'var(--gold)' }}>*</span></label>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="example@email.com" />
                  </div>
                  <div style={{ textAlign: 'center', marginTop: '40px' }}>
                    <button type="submit" className="btn-primary-custom">
                      検査を開始する（7分間）
                    </button>
                  </div>
                </form>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }

  // 送信完了
  if (submitted) {
    return (
      <div className="contact-page">
        <section className="page-header">
          <Container>
            <h1 className="page-title">Assessment</h1>
            <p className="page-subtitle">性格適性検査</p>
          </Container>
        </section>
        <section className="section-contact-form">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <div style={{ textAlign: 'center', padding: '60px 0' }}>
                  <h3 style={{ fontSize: '1.4rem', fontWeight: 300, color: 'var(--text-primary)', marginBottom: '16px' }}>
                    回答を送信しました。
                  </h3>
                  <p style={{ fontSize: '14px', color: 'var(--text-secondary)', lineHeight: 2 }}>
                    回答数: {answeredCount} / 84 問<br />
                    ご協力ありがとうございました。<br />
                    次のステップについては、メールでご案内いたします。
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }

  // 検査中
  return (
    <div className="contact-page">
      <section className="page-header">
        <Container>
          <h1 className="page-title">Assessment</h1>
          <p className="page-subtitle">性格適性検査</p>
        </Container>
      </section>

      {/* タイマー（固定表示） */}
      <div style={{
        position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
        background: timeLeft <= 60 ? 'rgba(180, 40, 40, 0.98)' : 'rgba(10, 15, 26, 0.98)',
        borderTop: '1px solid var(--gold-border)',
        padding: '14px 0',
        textAlign: 'center',
        transition: 'background 0.5s',
        backdropFilter: 'blur(10px)',
      }}>
        <Container>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '32px' }}>
            <span style={{ fontSize: '14px', color: 'var(--text-tertiary)' }}>
              回答: {answeredCount} / 84
            </span>
            <span style={{
              fontSize: '24px', fontFamily: 'var(--font-display)', color: timeLeft <= 60 ? '#fff' : 'var(--gold)',
              fontWeight: 600, letterSpacing: '0.05em',
            }}>
              {minutes}:{seconds.toString().padStart(2, '0')}
            </span>
            <button
              onClick={handleSubmit}
              disabled={submitting}
              style={{
                padding: '6px 24px', border: '1px solid var(--gold-border)', borderRadius: '3em',
                background: 'transparent', color: 'var(--text-primary)', fontSize: '13px',
                cursor: 'pointer', fontFamily: 'var(--font-body)',
              }}
            >
              {submitting ? '送信中...' : '回答を送信'}
            </button>
          </div>
        </Container>
      </div>

      {/* 質問一覧 */}
      <section style={{ padding: '80px 0 60px' }}>
        <Container>
          <Row className="justify-content-center">
            <Col lg={8}>
              {QUESTIONS.map((q, i) => (
                <div key={i} style={{
                  padding: '20px 0',
                  borderBottom: '1px solid rgba(200, 165, 90, 0.1)',
                }}>
                  <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                    <span style={{
                      fontSize: '13px', color: 'var(--gold)', minWidth: '28px',
                      fontFamily: 'var(--font-display)', paddingTop: '2px',
                    }}>
                      {i + 1}.
                    </span>
                    <div style={{ flex: 1 }}>
                      <p style={{
                        fontSize: '15px', color: 'var(--text-primary)', margin: '0 0 12px 0',
                        lineHeight: 1.7,
                      }}>
                        {q}
                      </p>
                      <div style={{ display: 'flex', gap: '12px' }}>
                        <button
                          type="button"
                          onClick={() => handleAnswer(i, 'yes')}
                          style={{
                            padding: '6px 28px',
                            border: answers[i] === 'yes' ? '1px solid var(--gold)' : '1px solid var(--gold-border)',
                            borderRadius: '3em',
                            background: answers[i] === 'yes' ? 'var(--gold)' : 'transparent',
                            color: answers[i] === 'yes' ? 'var(--bg-primary)' : 'var(--text-secondary)',
                            fontSize: '13px',
                            cursor: 'pointer',
                            fontFamily: 'var(--font-body)',
                            transition: 'all 0.2s',
                          }}
                        >
                          はい
                        </button>
                        <button
                          type="button"
                          onClick={() => handleAnswer(i, 'no')}
                          style={{
                            padding: '6px 28px',
                            border: answers[i] === 'no' ? '1px solid var(--gold)' : '1px solid var(--gold-border)',
                            borderRadius: '3em',
                            background: answers[i] === 'no' ? 'var(--gold)' : 'transparent',
                            color: answers[i] === 'no' ? 'var(--bg-primary)' : 'var(--text-secondary)',
                            fontSize: '13px',
                            cursor: 'pointer',
                            fontFamily: 'var(--font-body)',
                            transition: 'all 0.2s',
                          }}
                        >
                          いいえ
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              <div style={{ textAlign: 'center', marginTop: '40px', paddingBottom: '40px' }}>
                <button
                  onClick={handleSubmit}
                  className="btn-primary-custom"
                  disabled={submitting}
                >
                  {submitting ? '送信中...' : '回答を送信する'}
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default RecruitAssessmentPage;
